import React from 'react';
import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';

import * as ds from './dataService';

export type SaveFolderFormProps = {
  id: string;
  projectId: string;
  handleClose: () => void;
};

export const FC = (props: SaveFolderFormProps) => {
  const [
    fnSaveForm,
    { loading }
  ] = ds.useSaveFolder();
  const form = ds.useFormState(props.id, props.projectId);
  const handleSubmit = async () => {
    const input = {
      ...form.formState
    };
    await fnSaveForm(input);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit();
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <StyledTextField.FC
        {...form.genFieldProps('name')}
      />
    </FormBaseLayout.FC>

  );
};
